import {StorageWrapper} from '../../../shared/scripts/StorageWrapper'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {UIGameCanvasController} from '../../../shared/scripts/ui_game/UIGameCanvasController'
import {UIGameResponsiveController} from '../../../shared/scripts/ui_game/UIGameResponsiveController'
import {UIMGameManager} from './UIMGameManager'
import {UIMGameResponsiveController} from './UIMGameResponsiveController'

export class UIMGameCanvasController extends UIGameCanvasController {
    readonly responsiveController: UIGameResponsiveController
    // eslint-disable-next-line class-methods-use-this
    get chatWidth(): number {
        return 0
    }
    // eslint-disable-next-line class-methods-use-this
    get feedsHeight(): number {
        return 0
    }
    // eslint-disable-next-line class-methods-use-this
    get popupWidth(): number {
        return UIUtilsEjsVariables.isUserOnTabletApp ? this.appW / 2 : this.appW
    }

    get bottomViewHeight(): number {
        const bottomSafeAreaInset = UIUtilsEjsVariables.isUserOnTabletApp ? 0 : StorageWrapper.getSafeAreaInsetBottom() ?? 0
        const bottomViewHeight = this.itemSize * 1.2 + bottomSafeAreaInset * 0.5

        const root = document.querySelector(':root') as HTMLElement
        root?.style.setProperty('--bottom-view-height', `${bottomViewHeight}px`)
        return bottomViewHeight
    }

    constructor(uiGameManager: UIMGameManager) {
        super(uiGameManager)
        this.responsiveController = new UIMGameResponsiveController(uiGameManager)
    }

    setupGameContainers() {
        super.setCanvasConfigVariables()

        this.kickOffAppLoading()
        this.addTicker()
    }
}
